<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .newsfeed
        position: relative
        background: #54d52b url(../../common/assets/background-newsfeed.svg) no-repeat center center / cover

        .title--2
            color: white

        &__wrapper
            margin: $baseline $baseline*1.5
            +media('>small')
                margin-left: $baseline*2
                margin-right: $baseline*2

        &__slider
            &.swiper
                z-index: 0
                +media('>xsmall')
                    overflow: visible

        &__slide
            box-sizing: border-box
            padding-right: .625rem
            padding-left: .625rem
            opacity: 0
            pointer-events:  none
            transition: opacity $speed-normal $authentic-motion-sharp

            a
                position: relative
                display: block
                background-color: white
                border-radius: inherit
                height: 100%
                text-decoration: none
                color: inherit
                &.offer
                  color: white

            &.card
                height: auto
                margin: 0

            .card__cover
                min-width: 100%
                max-width: 100%
            .card__label
                background-color: $color-base-light

            &.swiper-slide-active
                opacity: 1
                pointer-events:  initial
                transition: opacity $speed-normal $authentic-motion-out

            &.swiper-slide-next
                +media('>=768px')
                    opacity: 1
                    pointer-events:  initial
                    transition: opacity $speed-normal $authentic-motion-out

            &.swiper-slide-next + &.swiper-slide
                +media('>=medium')
                    opacity: 1
                    pointer-events:  initial
                    transition: opacity $speed-normal $authentic-motion-out

            p
                margin-bottom: 0

            &__body
                padding: 1.25rem

                > * + *
                    margin-top: .75rem

        &__nav
            position: absolute
            z-index: 1
            top: 56%
            width: 1.75rem
            height: 1.75rem
            cursor: pointer
            transform: scale(.9)
            transition: transform $speed-normal $authentic-motion, opacity $speed-normal $authentic-motion

            &--left
                left: 0
                &:hover
                    transform: translateX(-25%)

            &--right
                right: 0
                &:hover
                    transform: translateX(25%)

            &.swiper-button-disabled
                opacity: 0
                pointer-events: none

            svg
                height: inherit
                width: inherit
                stroke: white
                stroke-width: 2

        &--grid

            .newsfeed__wrapper
                padding-left: 4.166666665%
                padding-right: 4.166666665%

                .row
                    flex-wrap: wrap

                    > *
                        margin-bottom: 1.375rem

</style>


<script>
   import { Navigation } from 'swiper/modules';
   import { Swiper, SwiperSlide } from "swiper/vue";
    export default {
      props:{
        uuid: { type: String, required: false },
      },
      components:{
        Swiper,
        SwiperSlide
      },
        setup(props){

          return {
            uuid: props.uuid,
            modules: [Navigation]
          }
        }
    }

</script>
